import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "@rdxmodules/enterpriseEarnings/messages";
import { camelizeKeys } from "@helpers";

function* getEnterpriseEarnings(action) {
  const params = {
    ...action.payload,
  };
  const { success, data, error } = yield* makeRequest.get("/enterprise/ledger", params);

  if (success && data) {
    if (data.body.payments) {
      yield put(actions.setEnterpriseEarningsList(camelizeKeys(data.body)));
    }
    if (data.body.filters) {
      yield put(actions.setEnterpriseEarningsFilters(data.body.filters));
    }
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_ENTERPRISE_USERS_LIST,
    });
  }
  return null;
}

export default getEnterpriseEarnings;
